/**
 * ZenMarkup Privacy Analytics — Pie Chart legend & touch interaction.
 *
 * Legend rows with colored dots, and tap-to-show-segment tooltip.
 * Extracted from pie-chart.js to keep modules under 200 lines.
 */

const COLORS = { new: '#2563EB', returning: '#CBD5E1' };
const LABELS = { new: 'New', returning: 'Returning' };

/**
 * Build legend rows. When hidden=true, rows start invisible
 * and fade in when the container gets zmpa-pie-legend-visible.
 *
 * @param {Object}  data   { new: int, returning: int }
 * @param {number}  total  Sum of new + returning.
 * @param {boolean} hidden Start with rows hidden (for animation).
 */
export function drawLegend(data, total, hidden) {
	const container = document.querySelector('[data-el="pie-legend"]');
	if (!container) return;
	container.innerHTML = '';
	container.classList.toggle('zmpa-pie-legend-visible', !hidden);

	const segments = [
		{ key: 'new', value: data.new || 0 },
		{ key: 'returning', value: data.returning || 0 }
	];

	segments.forEach(function (seg) {
		const row = document.createElement('div');
		row.className = 'zmpa-pie-legend-row';

		const dot = document.createElement('span');
		dot.className = 'zmpa-pie-dot';
		dot.style.backgroundColor = COLORS[seg.key];

		const label = document.createElement('span');
		label.className = 'zmpa-pie-label';
		label.textContent = LABELS[seg.key];

		const count = document.createElement('span');
		count.className = 'zmpa-pie-count';
		count.textContent = Number(seg.value).toLocaleString();

		row.appendChild(dot);
		row.appendChild(label);
		row.appendChild(count);
		container.appendChild(row);
	});
}

/**
 * Show legend by adding the visible class.
 */
export function showLegend() {
	var container = document.querySelector('[data-el="pie-legend"]');
	if (container) {
		container.classList.add('zmpa-pie-legend-visible');
	}
}

/** Bind tap/click to show segment tooltip on the donut. */
export function bindTouch(canvas, data, total) {
	if (!canvas || total === 0) return;

	let tip = canvas.parentElement.querySelector('.zmpa-pie-tooltip');
	if (!tip) {
		tip = document.createElement('div');
		tip.className = 'zmpa-pie-tooltip';
		tip.style.display = 'none';
		canvas.parentElement.style.position = 'relative';
		canvas.parentElement.appendChild(tip);
	}

	let hideTimer = 0;

	function handleTap(e) {
		e.preventDefault();
		const rect = canvas.getBoundingClientRect();
		const clientX = e.touches ? e.touches[0].clientX : e.clientX;
		const clientY = e.touches ? e.touches[0].clientY : e.clientY;
		const x = clientX - rect.left - rect.width / 2;
		const y = clientY - rect.top - rect.height / 2;
		const dist = Math.sqrt(x * x + y * y);
		const outerR = rect.width / 2;
		const innerR = outerR * (40 / 70);

		if (dist < innerR || dist > outerR) {
			tip.style.display = 'none';
			return;
		}

		let angle = Math.atan2(y, x) + Math.PI / 2;
		if (angle < 0) angle += Math.PI * 2;

		const newRatio = (data.new || 0) / total;
		const seg = angle <= newRatio * Math.PI * 2 ? 'new' : 'returning';
		const val = data[seg] || 0;
		const pct = Math.round((val / total) * 100);

		tip.textContent = LABELS[seg] + ': ' + val.toLocaleString() + ' (' + pct + '%)';
		tip.style.display = 'block';

		clearTimeout(hideTimer);
		hideTimer = setTimeout(function () {
			tip.style.display = 'none';
		}, 2500);
	}

	canvas.addEventListener('touchstart', handleTap, { passive: false });
	canvas.addEventListener('click', handleTap);
}
